import React, { useEffect, useState } from "react";
import { Container } from "@mui/material";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import { useNavigate } from "react-router-dom";

import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import { Menu, MenuItem } from "@szhsin/react-menu";

import dayjs from "dayjs";
import Box from "@mui/material/Box";

import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";
import SubTitle from "../../components/SubTitle";

import { hasError, getError } from "../../services/ServiceHelper";

import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "../../ResponsiveTable.css";
import { getThisWeeksMonday, getThisWeeksFriday } from "../../services/DateService";
import { getTeacherCoursesForDateRange, getCourseStartTime, getCourseEndTime } from "../../services/CourseService";
import { showToast } from "../../components/ATPDialogs";

const CourseThisWeek = () => {
  const navigate = useNavigate();

  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();
  const [showProgress, setShowProgress] = useState(false);

  const [_courses, setCourses] = useState([]);

  useEffect(() => {
    initCourses();
  }, []);


  const initCourses = () => {
    setShowProgress(true);
    const startDate = getThisWeeksMonday();
    const endDate = getThisWeeksFriday();

    getTeacherCoursesForDateRange(_school, _jwt, startDate, endDate)
      .then((result) => {
        if (hasError(result.data) === true) {
          showToast("E", "Unable to get Courses: ", getError(result.data));
        } else {
          setCourses(result.data);
        }
      })
      .catch((error) => {
        console.log(error);
        showToast("E", "Unable to get Day.");
      })
      .finally(() => {

        setShowProgress(false);
      });
  };

  const gotoTakeAttendance = (course) => {
    navigate(`/teacher/course/${course.courseDateEid}/attendance/take`);
  };


  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="Courses for This Week" showBack={true} />
        <ProgressBar showProgress={showProgress} />

        <Box sx={{ boxShadow: 1, p: 1, mt: 2 }}>
          <SubTitle text="My Courses" />

          <Table>
            <Thead>
              <Tr>
                <Th>Date/Day</Th>
                <Th>Time</Th>
                <Th>Name/Location</Th>
                <Th>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {_courses.map((activity) => (
                <Tr key={activity.activityDateId}>
                  <Td>
                    <span style={{ fontWeight: 600 }}>
                      {dayjs(activity.date).format("MM/DD/YYYY")}
                    </span>
                    <br />
                    {activity.fullDay}
                  </Td>
                  <Td>{getCourseStartTime(_school, activity)}-{getCourseEndTime(_school, activity)}</Td>
                  <Td>
                    <span style={{ fontWeight: 600 }}>
                      <Link className="link-pointer" onClick={() => gotoTakeAttendance(activity)}>
                      {activity.name}
                      </Link>
                    </span>
                    <br />
                    {activity.schoolLocationName}
                  </Td>
                  <Td>
                    <Menu menuButton={<Button>Actions</Button>} transition>
                      <MenuItem
                        value={activity.eid}
                        onClick={() => gotoTakeAttendance(activity)}
                      >
                        Take Attendance
                      </MenuItem>
                    </Menu>
                  </Td>
                </Tr>
              ))}
              {_courses.length === 0 && (
                <Tr>
                  <Td colSpan={10}>-- NO COURSES FOR THIS WEEK --</Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </Box>

      </Container>
    </>
  );
};

export default CourseThisWeek;
